import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export default class Nav {
    constructor() {

        this.init();
        this.startX = 0;
        this.startY = 0;

    }

    init() {

        this.navHeight();
        this.navBeforeHeight();

        this.initShowHideNav();
        this.initNavCtas();

        this.initNavSearch();
        this.initNavCart();
        this.initNavBurger();

        this.initResponsiveSubMenus();

        this.initSwipeListeners();

        this.attachAnchorListeners();
        this.scrollToAnchorOnLoad();

        this.initSearchModal();
        this.initLanguageMenu();

    }

    // === NAVHEIGHT ===
    navHeight() {
        const navElement = document.querySelector('nav');
        if( navElement ) {
            const navHeight = navElement.offsetHeight;
            document.documentElement.style.setProperty('--navHeight', `${navHeight}px`);
            return navHeight;
        }
        return 0;
    }
    navBeforeHeight() {
        const navBeforeElement = document.querySelector('.nav-before');
        if( navBeforeElement ) {
            const navBeforeHeight = navBeforeElement.offsetHeight;
            document.documentElement.style.setProperty('--navBeforeHeight', `${navBeforeHeight}px`);
        }
    }

    // === SHOW/HIDE NAV ===
    initShowHideNav() {
        const showhideNav = gsap.from('.navContainer', {
            y: -65,
            paused: true,
            duration: 0.5,
        }).progress(1);

        const searchModal = document.querySelector('.search-modal');
        const navContainer = document.querySelector('.navContainer');

        ScrollTrigger.create({
            start: 'top top',
            end: 99999,
            onUpdate: (self) => {
                const navSticky = document.querySelector('.navContainer');

                if (self.direction === -1) {
                    showhideNav.play();
                } else {
                    showhideNav.reverse();
                }

                if (searchModal.classList.contains('active')) {
                    const navHeight = navSticky.getBoundingClientRect().bottom;
                    searchModal.style.top = `${navHeight}px`;
                }
            },
        });
    }

    initNavCtas() {
        const ctaElements = document.querySelectorAll('.nav-before_content .cta');
        const screenWidth = window.innerWidth;

        if( screenWidth <= 1200 ) {
            for (let i = ctaElements.length - 3; i < ctaElements.length; i++) {
                if (ctaElements[i]) {
                    ctaElements[i].classList.add('show');
                }
            }
        }
    }

    // === NAV SEARCH ===
    initNavSearch() {
        document.querySelectorAll(".nav-search").forEach(item => {
            item.addEventListener("click", () => {
                this.toggleSearchModal(item);
            });
        });
    }

    // === TOGGLE SEARCH MODAL ===
    toggleSearchModal(triggerElement) {
        const searchModal = document.querySelector(".search-modal");
        const navContainer = document.querySelector(".navContainer");

        const navHeight = navContainer.getBoundingClientRect().bottom;

        searchModal.style.top = `${navHeight}px`;

        const isActive = searchModal.classList.contains("active");

        if (!isActive) {
            searchModal.style.display = 'flex';
            gsap.fromTo(searchModal, {
                x: '100%',
                opacity: 0
            }, {
                x: '0%',
                opacity: 1,
                duration: 0.5,
                onComplete: () => {
                    searchModal.classList.add("active");
                }
            });

            document.documentElement.classList.add("block-viewport");
            document.body.classList.add("block-viewport");

            if (triggerElement) {
                triggerElement.classList.add("active");
            }
        } else {
            gsap.to(searchModal, {
                x: '100%',
                opacity: 0,
                duration: 0.5,
                onComplete: () => {
                    searchModal.style.display = 'none';
                    searchModal.classList.remove("active");
                    document.documentElement.classList.remove("block-viewport");
                    document.body.classList.remove("block-viewport");
                }
            });

            document.querySelectorAll(".nav-search.active").forEach(item => {
                item.classList.remove("active");
            });
        }
    }

    // === INIT SEARCH MODAL ===
    initSearchModal() {
        const searchModal = document.querySelector(".search-modal");
        if (searchModal) {
            searchModal.style.display = 'none'; // Assurez-vous que la modale est masquée par défaut
            document.querySelectorAll(".nav-search").forEach(item => {
                item.addEventListener("click", () => {
                    this.toggleSearchModal(item);
                });
            });
        }
    }

    // === NAV CART ===
    initNavCart() {
        document.querySelectorAll(".nav-cart").forEach(item => {
            item.addEventListener("click", () => this.toggleCart());
        });
        document.querySelectorAll(".nav-cart-modal .cart-close, .nav-cart-overlay").forEach(item => {
            item.addEventListener("click", () => this.toggleCart());
        });
    }

    // === TOGGLE NAV CART / NAV CART OVERLAY / NAV RESPONSIVE
    toggleCart() {
        const navCartModal = document.querySelector(".nav-cart-modal");
        const navCartOverlay = document.querySelector(".nav-cart-overlay");
        const navResponsive = document.querySelector(".nav-responsive");
        const isCartModalActive = navCartModal.classList.contains("active");
        navCartModal.classList.toggle("active");
        navCartOverlay.classList.toggle("active");
        if (!isCartModalActive) {
            navResponsive.classList.remove("active");
            document.querySelector(".nav-burger").classList.remove("active");
            document.documentElement.classList.add("block-viewport");
            document.body.classList.add("block-viewport");
        } else {
            if (!document.querySelector(".nav-search-modal.active")) {
                document.documentElement.classList.remove("block-viewport");
                document.body.classList.remove("block-viewport");
            }
        }
    }

    // === NAV BURGER ===
    initNavBurger() {
        document.querySelectorAll(".nav-burger, .nav-responsive-overlay").forEach(item => {
            item.addEventListener("click", () => {
                document.querySelector(".nav-burger").classList.toggle("active");
                document.querySelector(".nav-responsive").classList.toggle("active");
                document.querySelector(".nav-responsive-overlay").classList.toggle("active");
                document.documentElement.classList.toggle("block-viewport");
                document.body.classList.toggle("block-viewport");
            });
        });
    }

    // === SWIPE NAV LISTENER ===
    initSwipeListeners() {
        const navResponsive = document.querySelector('.nav-responsive');
        const navCartModal = document.querySelector('.nav-cart-modal');
        if (navResponsive) {
            navResponsive.addEventListener('touchstart', (e) => this.handleTouchStart(e), false);
            navResponsive.addEventListener('touchmove', (e) => this.handleTouchMove(e, 'responsive'), false);
        }
        if (navCartModal) {
            navCartModal.addEventListener('touchstart', (e) => this.handleTouchStart(e), false);
            navCartModal.addEventListener('touchmove', (e) => this.handleTouchMove(e, 'cart'), false);
        }
    }

    handleTouchStart(e) {
        const firstTouch = e.touches[0];
        this.startX = firstTouch.clientX;
        this.startY = firstTouch.clientY;
    }

    handleTouchMove(e, type) {
        if (!this.startX || !this.startY) {
            return;
        }
        const moveEndX = e.touches[0].clientX;
        const moveEndY = e.touches[0].clientY;
        const diffX = this.startX - moveEndX;
        const diffY = this.startY - moveEndY;
        if (Math.abs(diffX) > Math.abs(diffY)) {
            if (diffX > 0 && type === 'responsive') {
                this.closeNavResponsive();
            } else if (diffX < 0 && type === 'cart') {
                this.toggleCart(false);
            }
        }
        this.startX = 0;
        this.startY = 0;
    }

    // === CLOSE NAV REPSONSIVE ===
    closeNavResponsive() {
        document.querySelector('.nav-responsive').classList.remove('active');
        document.querySelector('.nav-burger').classList.remove('active');
        this.manageViewportBlock(false);
    }

    // === BLOCKVIEWPORT ===
    manageViewportBlock(shouldBlock) {
        if (shouldBlock) {
            document.documentElement.classList.add("block-viewport");
            document.body.classList.add("block-viewport");
        } else {
            if (!document.querySelector('.nav-cart-modal.active') && !document.querySelector('.nav-search-modal.active')) {
                document.documentElement.classList.remove("block-viewport");
                document.body.classList.remove("block-viewport");
            }
        }
    }

    // === RESPONSIVE SUB MENU ===
    initResponsiveSubMenus() {
        document.querySelectorAll(".nav-responsive ul.menu > li.menu-item-has-children > a").forEach(function(link) {
            link.addEventListener("click", function(e) {
                e.preventDefault();
                e.stopPropagation();
                const parentLi = this.closest("li.menu-item-has-children");
                const subMenu = parentLi.querySelector("ul.sub-menu");
                const isActive = parentLi.classList.contains("active");

                // Fermer tous les sous-menus et retirer la classe active de tous les éléments
                document.querySelectorAll(".nav-responsive ul.menu li.menu-item-has-children").forEach(function(item) {
                    item.classList.remove("active");
                    item.querySelector("ul.sub-menu").style.display = "none";
                });

                if (!isActive) {
                    // Ajouter la classe active à l'élément cliqué et ouvrir son sous-menu
                    parentLi.classList.add("active");
                    subMenu.style.display = "block";

                    // Ouvrir les sous-menus imbriqués
                    subMenu.querySelectorAll("li.menu-item-has-children ul.sub-menu").forEach(function(nestedSubMenu) {
                        nestedSubMenu.style.display = "block";
                    });
                }
            });
        });
    }


    // === HREF HAVE ANCHOR ===
    attachAnchorListeners() {
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', (e) => {
                e.preventDefault();
                const targetId = anchor.getAttribute('href');
                if (targetId !== '#') {
                    const targetElement = document.querySelector(targetId);
                    if (targetElement) {
                        const navHeight = this.navHeight() + 30;
                        gsap.to(window, {
                            scrollTo: {
                                y: targetElement,
                                offsetY: navHeight,
                                autoKill: false
                            },
                            duration: 1
                        }).then(() => {
                            history.replaceState(null, null, ' ');
                        });
                    }
                }
            });
        });
    }


    // === SCROLL TO ANCHOR ===
    scrollToAnchorOnLoad() {
        const hash = window.location.hash;
        if (hash) {
            const targetElement = document.querySelector(hash);
            if (targetElement) {
                const navHeight = this.navHeight() + 75;
                gsap.to(window, {
                    scrollTo: {
                        y: targetElement,
                        offsetY: navHeight,
                        autoKill: false
                    },
                    duration: 1,
                    delay: 0.25
                }).then(() => {
                    history.replaceState(null, null, ' ');
                });
            }
        }
    }


    // === INIT LANGUAGE MENU ===
    initLanguageMenu() {
        const toggleButton = document.querySelector('.js-wpml-ls-item-toggle');
        const subMenu = document.querySelector('.js-wpml-ls-sub-menu');

        if (toggleButton && subMenu) {
            gsap.set(subMenu, { opacity: 0, y: '-50%', display: 'none' });

            toggleButton.addEventListener('click', (e) => {
                e.preventDefault();
                const isSubMenuVisible = subMenu.classList.contains('visible');

                if (isSubMenuVisible) {
                    gsap.to(subMenu, {
                        opacity: 0,
                        y: '-50%',
                        duration: 0.25,
                        onComplete: () => {
                            subMenu.classList.remove('visible');
                            subMenu.style.display = 'none';
                        }
                    });
                } else {
                    subMenu.style.display = 'block';
                    gsap.fromTo(subMenu, {
                        opacity: 0,
                        y: '-50%'
                    }, {
                        opacity: 1,
                        y: '0%',
                        duration: 0.25,
                        onComplete: () => {
                            subMenu.classList.add('visible');
                        }
                    });
                }
            });
        }
    }

}
